
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../base/BaseComponent";
import {Button, Dropdown, Icon, Input, Menu, Select} from "antd";
const { Option } = Select;


export default class FileSize extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            checkCode:'',//大小的值
            data:'',
            sizeCondition:"0",//符号
            visible:false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    sizeChange = (e) => {
      if(e.target.value){
          let num = e.target.value
          if(num){
              let value = num.replace(/[^\d]/,'');
              num = value*1
          }
          this.setState({ checkCode: num });
      }else{
          this.setState({ checkCode: '' });
      }

    }

    //选择符号
    getSymbol(type, data) {
        this.state[type] = data;
    }

    //确定按钮
    getValue=()=>{
        const {checkCode,sizeCondition}=this.state
        if(typeof this.props.onClickCall == "function"){
            this.props.onClickCall([{type:"sizeCondition",data:parseInt(sizeCondition)},{type:"size",data:checkCode}]);
        }
    }
    render() {
        //大小
        let isSmall;
        if (this.state.checkCode) {
            isSmall = this.state.sizeCondition == 0 ? '>' + this.state.checkCode : '<='  + this.state.checkCode
        } else {
            isSmall = '大小不限'
        }
        return (
            <Dropdown
                overlay={this.renderMenu()}
                trigger={["click"]}
                style={{display: 'none'}}
                onClick={() => {
                    // this.setState({visible: true})
                }}
            >
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {isSmall}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }

    renderMenu=()=> {
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return (
            <Menu
                onClick={()=>{
                    this.setState({})
                }}
                ref={ref => this.menu = ref}
                style={{padding: '16px', fontSize: '12px', width: '190px', background: '#ffffff', marginTop: '7px'}}
            >
                <div className={'fileSize'}>
                    {/*<div style={{lineHeight:'40px',fontSize:'14px'}} onClick={()=>{}}>大小不限</div>*/}
                    <Select defaultValue="0"
                            dropdownStyle={{width:'46px'}}
                            onChange={(value)=>{this.getSymbol('sizeCondition',value)}}>
                        <Option value="0">&gt;</Option>
                        <Option value="1">&lt;=</Option>
                    </Select>
                    <Input style={{width:'66px',marginLeft:'4px',marginRight:'4px'}}
                           value={this.state.checkCode}
                           maxLength = {5}
                           onChange={(e,index)=>this.sizeChange(e)}/>
                    <span style={{color:"rgba(0, 0, 0, 0.65)"}}>MB</span>
                    <div style={{borderTop:'1px solid rgba(240, 240, 240, 1)',marginTop:'16px',display: 'flex', justifyContent: 'flex-end'}}>
                        <Button type="primary"
                                style={{
                                    width: '44px', height: '24px', background: 'rgba(0, 80, 179, 1)',
                                    color: 'rgba(255, 255, 255, 1)', fontSize: '12px', padding: '0', marginTop: '10px'
                                }}
                                onClick={() => {
                                  this.state.checkCode ='';
                                  this.setState({},()=>{
                                      this.getValue()
                                      this.menu.props.onClick();
                                  })
                                }}
                        >重置</Button>
                        <Button type="primary"
                                style={{
                                    width: '44px', height: '24px', background: 'rgba(0, 80, 179, 1)',marginLeft:10,
                                    color: 'rgba(255, 255, 255, 1)', fontSize: '12px', padding: '0', marginTop: '10px'
                                }}
                                onClick={() => {
                                    this.getValue()
                                    this.menu.props.onClick();
                                }}
                        >确定</Button>
                    </div>
                    <style>
                        {'.fileSize .ant-select-selection__rendered {margin-left: 8px}'}
                        {'.fileSize .ant-select-selection-selected-value {margin-right: 7px}'}
                        {`.fileSize .ant-input:focus, .ant-input:hover {border-color:${newSecondSelectColor} !important}`}
                    </style>
                </div>
            </Menu>

        )
    }




}